import { render, staticRenderFns } from "./JoinableAgent.vue?vue&type=template&id=06512515&scoped=true"
import script from "./JoinableAgent.vue?vue&type=script&lang=js"
export * from "./JoinableAgent.vue?vue&type=script&lang=js"
import style0 from "./JoinableAgent.vue?vue&type=style&index=0&id=06512515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06512515",
  null
  
)

export default component.exports